module.exports = __webpack_public_path__ + "img/40_38_077_320.37035755.jpg";